module.exports = __webpack_public_path__ + "img/AstroFrens1.ddb21fce.jpg";